import {
	Input as StyledInput,
	type InputProps as StyledInputProps,
} from 'components/FormUi';

import { useValidatedController } from './hooks';

interface Props extends StyledInputProps {
	className?: string;
	name: string;
	patternErrorMessage?: string;
	requiredErrorMessage?: string;
}

export default function TextInput({
	className,
	defaultValue,
	disabled,
	name,
	pattern,
	patternErrorMessage,
	required,
	requiredErrorMessage,
	...rest
}: Props) {
	const { errorMessage, invalid, onBlur, onChange, valid, value } =
		useValidatedController({
			name,
			defaultValue,
			pattern,
			patternErrorMessage,
			requiredErrorMessage,
			required,
			disabled,
		});

	return (
		<StyledInput
			onChange={onChange}
			onBlur={onBlur}
			value={value}
			invalid={invalid}
			valid={valid}
			errorMessage={errorMessage}
			className={className}
			required={required}
			disabled={disabled}
			{...rest}
		/>
	);
}
TextInput.displayName = 'ReactHookForm_TextInput';
